export enum HTTP_METHOD {
  GET,
  POST,
  PUT,
  DELETE,
  PATCH,
}

export const ACTIVATION_STATUS = {
  1: '無効',
  0: '有効',
};

export const DB_TYPE = {
  PRIVATE: 'Private DB',
  CLUSTER: 'Cluster DB',
};
export const dbTypeOpts: Option[] = [
  { label: 'Private DB', value: 'private' },
  { label: 'Cluster DB', value: 'cluster' },
];

export const APPROXIMATE_LICENSE_OPTS = {
  0: 'いいえ',
  1: 'はい',
};

export enum FACE_DB_TYPE {
  Private = 'private',
  Cluster = 'cluster',
}

export enum ROLE_TYPE {
  OWNER = 'owner',
  CO_OWNER = 'coOwner',
  SYSTEM = 'system',
  VIEW = 'view',
  SEARCH = 'search',
}

export const FILE_UPLOAD_ACCEPTABLE =
  'image/jpeg,image/jpg,image/png,image/bmp,image/tiff';

export const allowImgExt = ['jpeg', 'png', 'bmp', 'tiff', 'jpg'];

export const GENDER_OPTIONS = {
  MALE: 'user_id_detail.male',
  FEMALE: 'user_id_detail.female',
};

export const USER_ID_DETAIL_DEFAULT_VALUE = {
  id: '',
  imageUrl: '',
  displayName: '',
  tag: '',
  originalData: '',
  gender: '',
  age: 0,
  idNumber: '',
  phoneNumber: '',
  affiliation: '',
  group: '',
  title: '',
};
